<!-- eslint-disable max-len -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="20" viewBox="0 0 4 20" fill="none">
    <path d="M2 6.43066C2.7965 6.43066 3.5 7.13386 3.5 8.07422V17.8574C3.49987 18.7977 2.79643 19.5 2 19.5C1.20357 19.5 0.500129 18.7977 0.5 17.8574V8.07422C0.5 7.13386 1.2035 6.43066 2 6.43066ZM1.87598 0.5H2.12402C2.85195 0.5 3.49995 1.14289 3.5 2.00977C3.5 2.87669 2.85198 3.51953 2.12402 3.51953H1.87598C1.14802 3.51953 0.5 2.87669 0.5 2.00977C0.500053 1.14289 1.14805 0.5 1.87598 0.5Z" :fill="fillColor" :stroke="strokeColor"/>
  </svg>
</template>

<script>
export default {
  name: 'HelpCenterIcon',
  props: {
    fillColor: {
      type: String,
      default: '#9E9E9E',
    },
    strokeColor: {
      type: String,
      default: '#293241',
    },
  },
};
</script>
